// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hints_L4_xp {
  max-width: 480px;
}

.hintLabel_iKY7M {
  max-width: 120px;
}`, "",{"version":3,"sources":["webpack://./src/screens/scenario/BehaviorEditor.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".hints {\n  max-width: 480px;\n}\n\n.hintLabel {\n  max-width: 120px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hints": `hints_L4_xp`,
	"hintLabel": `hintLabel_iKY7M`
};
export default ___CSS_LOADER_EXPORT___;
